import {
  createContext,
  type PropsWithChildren,
  useCallback,
  useContext,
  useState,
} from 'react'
import { useModalState } from '@vtex/admin-ui'
import { ProductSKUsOffersModal } from '@/components/products-listing/ProductSKUsOffersModal'
import { type Product } from '@/types/product'

type ProductSKUsOffersModalContextValue = {
  show: (product: Product, skuId?: number) => void
}

export const ProductSKUsOffersModalContext =
  createContext<ProductSKUsOffersModalContextValue | null>(null)

export const ProductSKUsOffersModalProvider = ({
  children,
}: PropsWithChildren) => {
  const productSKUsOffersModalState = useModalState()
  const [skuIdToOpen, setSkuIdToOpen] = useState<number | undefined>()
  const [product, setProduct] = useState<Product | undefined>()

  const show = useCallback((product: Product, skuId?: number) => {
    setSkuIdToOpen(skuId)
    setProduct(product)
    productSKUsOffersModalState.show()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <ProductSKUsOffersModalContext.Provider value={{ show }}>
        {children}
      </ProductSKUsOffersModalContext.Provider>
      <ProductSKUsOffersModal
        state={productSKUsOffersModalState}
        product={product}
        skuIdToOpen={skuIdToOpen}
      />
    </>
  )
}

export const useProductSKUsOffersModal = () => {
  const context = useContext(ProductSKUsOffersModalContext)

  if (!context) {
    throw new Error(
      'useProductSKUsOffersModal must be used within a ProductSKUsOffersModalProvider'
    )
  }

  return context
}
